import { FC } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { inherits } from 'util';

const LoadingIndicator: FC<{ large?: boolean; text?: string; floating?: boolean; style?: any }> = ({
  large,
  text,
  floating,
  style,
}) => {
  const textLoadingstyles = {
    borderRadius: '0.475rem',
    boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
    backgroundColor: '#fff',
    color: '#7e8299',
    fontWeight: '800',
    fontSize: large ? '25px' : 'inherit',
    margin: '0',
    width: 'auto',
    padding: '1rem 2rem',
    top: 'calc(50%)',
    left: large ? 'calc(50%)' : 'calc(50% - 7rem)',
    zIndex: 10,
  };

  const spinnerLoadingstyles = {
    margin: '0',
    width: 'auto',
    padding: '1rem 2rem',
    top: 'calc(50%)',
    left: 'calc(50%)',
    zIndex: 10,
  };

  return text ? (
    <div style={{ ...textLoadingstyles, position: 'absolute', textAlign: 'center' }}>{text}</div>
  ) : floating ? (
    <div style={{ ...spinnerLoadingstyles, position: 'absolute', textAlign: 'center', ...style }}>
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  ) : (
    <>
      <div className="d-flex justify-content-center">
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </div>
    </>
  );
};

export { LoadingIndicator };
